"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Rules = void 0;
var tslib_1 = require("tslib");
// (C) 2007-2020 GoodData Corporation
var ts_invariant_1 = tslib_1.__importDefault(require("ts-invariant"));
var find_1 = tslib_1.__importDefault(require("lodash/find"));
var every_1 = tslib_1.__importDefault(require("lodash/every"));
var Rules = /** @class */ (function () {
    function Rules() {
        this.rules = [];
    }
    Rules.prototype.addRule = function (tests, callback) {
        this.rules.push([tests, callback]);
    };
    // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
    Rules.prototype.match = function (subject, params) {
        var _a = find_1.default(this.rules, function (_a) {
            var tests = _a[0];
            return every_1.default(tests, function (test) { return test(subject, params); });
        }), callback = _a[1];
        ts_invariant_1.default(callback, "No suitable rule to handle the parameters found.");
        return callback;
    };
    return Rules;
}());
exports.Rules = Rules;
//# sourceMappingURL=rules.js.map